export default "__VITE_ASSET__XwrkEYr5__"